import NotificationDot from './notification-dot';

export { NotificationDot };

export default NotificationDot;
